import React, { useCallback } from "react";
import clsx from "clsx";
import {
    Divider,
    ListItem,
    ListItemIcon,
    ListItemText,
    SwipeableDrawer,
    useMediaQuery,
} from "@mui/material/";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import actions from "../../../Store/actions";
import styles from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
type Props = {
    items: Array<any>,
    onClose: Function,
    open: boolean,
};

/**
 * App Drawer Component
 * @param {Props} props
 */
export default ({ items, onClose, open }: Props) => {
    let navigate = useNavigate();
    // const theme = useTheme();
    // const isXsDown = useMediaQuery(theme.breakpoints.down("xl"));
    const classes = makeStyles(styles)();
    const dispatch = useDispatch();
    const location = useLocation();
    const currentPath = location.pathname.includes("settings")
        ? "settings"
        : "audits";

    const DrawerComponent = SwipeableDrawer; //isXsDown ? SwipeableDrawer : Drawer;

    const onListClick = useCallback(
        (item) => async () => {
            const { key, path } = item;
            // isXsDown ? onClose() : null; //  TODO: needs to investigate if this is still necessary
            if (key === "logout") {
                await dispatch(actions.auth.create.logout());
                await dispatch(actions.organisation.create.clear());
                await dispatch(actions.appSettings.create.clear());
            }
            navigate(path);
            onClose();
        },
        []
    );

    return (
        <DrawerComponent
            items={items}
            anchor="left"
            classes={{
                paper: clsx(!open && classes.drawerClosed, classes.drawerPaper),
            }}
            className={clsx(classes.drawer, !open && classes.drawerClosed)}
            onClose={onClose}
            onOpen={() => {}}
            open={open}
            //  Commenting f
            // variant={isXsDown ? "temporary" : "permanent"}
            variant="temporary"
        >
            <div className={classes.appBarToolbarSpacer} />
            <Divider />
            {items.map((item) => {
                return (
                    <React.Fragment key={item.key}>
                        <ListItem
                            button
                            className={`${classes.listItem} ${
                                currentPath === item.key
                                    ? classes.activeItem
                                    : null
                            }`}
                            onClick={onListClick(item)}
                        >
                            <ListItemIcon className={classes.menuItemIcon}>
                                <item.Icon />
                            </ListItemIcon>
                            <ListItemText
                                classes={{ primary: classes.menuItemText }}
                                primary={item.primary}
                            />
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                );
            })}
        </DrawerComponent>
    );
};
